import Vue from 'vue';
import { mapGetters } from 'vuex';
import InlineText from '@editor/droplets/_bubble-options/components/inline-text';

export default Vue.component('accordion-section', {
  template: require('./template.html'),
  components: {
    InlineText,
  },
  computed: {
    ...mapGetters([
      'currentPage',
      'globalDragEl',
      'dragging',
    ]),
    watchDroplets() {
      const drps = this.section.droplets;
      let cls = '';
      if (drps.length < 1) {
        cls = 'drzDroplet-puddleDropped';
      }
      return cls;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    draggingTemplateDrp() {
      return this.globalDragEl === 'templateDroplet';
    },
  },
  data() {
    const renderKey = Date.now();
    return {
      renderKey,
      toolbar: [
        {
          type: 'bold',
          tip: 'Bold',
        },
        {
          type: 'italic',
          tip: 'Italic',
        },
        {
          type: 'underline',
          tip: 'Underline',
        },
        {
          type: 'fontSize',
          tip: 'Font Size',
          sizes: ['8', '9', '10', '11', '12', '14', '16', '24', '36'],
        },
        {
          type: 'fontName',
          tip: 'Font',
          fonts: [
            'Arial',
            'Arial Black',
            'Comic Sans MS',
            'Courier New',
            'Impact',
            'Lucida Console',
            'Source Sans Pro',
            'Times New Roman',
            'Verdana',
          ],
        },
        {
          type: 'foreColor',
          tip: 'Font Color',
          colors: [
            '#ffffff',
            '#cccccc',
            '#808080',
            '#343434',
            '#000000',
            '#C8E6C9',
            '#81C784',
            '#4CAF50',
            '#388E3C',
            '#1B5E20',
            '#B2EBF2',
            '#4DD0E1',
            '#00BCD4',
            '#0097A7',
            '#006064',
            '#BBDEFB',
            '#64B5F6',
            '#2196F3',
            '#1976D2',
            '#0D47A1',
            '#D1C4E9',
            '#9575CD',
            '#673AB7',
            '#512DA8',
            '#311B92',
            '#F8BBD0',
            '#F06292',
            '#E91E63',
            '#C2185B',
            '#880E4F',
            '#FFCDD2',
            '#E57373',
            '#F44336',
            '#D32F2F',
            '#B71C1C',
            '#FFE0B2',
            '#FFB74D',
            '#FF9800',
            '#F57C00',
            '#E65100',
            '#FFF9C4',
            '#FFF176',
            '#FFEB3B',
            '#FBC02D',
            '#F57F17',
          ],
        },
      ],
    };
  },
  name: 'accordion-section',
  props: [
    'section',
    'droplet',
    'display',
    'index',
  ],
  watch: {
    'section.droplets': function watchDroplets() {
      // bouncing the component key will force a re-render. This is needed
      // for dragula to re insert the draggable container. See @/directives/main.js
      this.renderKey = Date.now();
    },
  },
  methods: {
    emitOpenToolbar(v) {
      this.$emit('open-toolbar', v);
    },
    updateText(text) {
      const payload = {};
      payload.section = this.section;
      payload.title = text.trim() === '' ? false : text;
      if (this.section.title !== text) {
        this.$store.dispatch('setAccTitle', payload);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/accordion/components/section/index.js